import { css } from "lit";

export const styles = css`
  :host {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  main {
    padding: 3rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  @media (max-width: 768px) {
    main {
      padding: 1rem;
    }
  }
`;
